import React from "react";
import { PurchaseForm } from "./PurchaseForm";
import { StartForm } from "./StartForm";
import { RemoForm } from "./RemoForm";
import { EmailToMipForm } from "./EmailToMipForm";
import { EmailToMortgageComparison } from "./EmailToMortgageComparison";
import { EmailToRateTracker } from "./EmailToRateTracker";
import { RedirectToSignUpPurchase } from "./RedirectToSignUpPurchase";
import { RedirectToSignUpRemo } from "./RedirectToSignUpRemo";
import { RedirectToSignUpMip } from "./RedirectToSignUpMip";
import { FF2Step } from "../types";
import { RedirectToSecuredHomepage } from "./RedirectToSecuredHomepage";
import { MortgageTooSmall } from "./MortgageTooSmall";
import { SignupForm } from "./SignupForm";
import { MagicLinkSent } from "./MagicLinkSent";

export const getComponentToRender = (step: FF2Step) => {
  let componentToRender: JSX.Element;

  switch (step) {
    case FF2Step.Start:
      componentToRender = <StartForm />;
      break;
    case FF2Step.Purchase:
      componentToRender = <PurchaseForm />;
      break;
    case FF2Step.PurchaseToLet:
      componentToRender = <PurchaseForm />;
      break;
    case FF2Step.Remo:
      componentToRender = <RemoForm />;
      break;
    case FF2Step.EmailToMip:
      componentToRender = <EmailToMipForm />;
      break;
    case FF2Step.EmailToMortgageComparison:
      componentToRender = <EmailToMortgageComparison />;
      break;
    case FF2Step.RedirectToSignUpPurchase:
      componentToRender = <RedirectToSignUpPurchase />;
      break;
    case FF2Step.RedirectToSignUpRemo:
      componentToRender = <RedirectToSignUpRemo />;
      break;
    case FF2Step.RedirectToSignUpMip:
      componentToRender = <RedirectToSignUpMip />;
      break;
    case FF2Step.EmailToRateTracker:
      componentToRender = <EmailToRateTracker />;
      break;
    case FF2Step.RedirectToSecuredHomepage:
      componentToRender = <RedirectToSecuredHomepage />;
      break;
    case FF2Step.MortgageTooSmallPurchase:
      componentToRender = <MortgageTooSmall />;
      break;
    case FF2Step.MortgageTooSmallRemo:
      componentToRender = <MortgageTooSmall />;
      break;
    case FF2Step.Signup:
      componentToRender = <SignupForm />;
      break;
    case FF2Step.MagicLinkSent:
      componentToRender = <MagicLinkSent />;
      break;
    default:
      componentToRender = <StartForm />;
  }

  return componentToRender;
};
